
import { Component, Vue } from 'vue-property-decorator'
import { OrderResultListDto } from "@/api/buyCar";
import { toOrderReturn } from '@/utils/h5ToApp'
import Clipboard from 'clipboard';

@Component({
  name: 'SubmitSuccess',
})
export default class SubmitSuccess extends Vue {
  resultList: OrderResultListDto[] = []

  created () {
    this.resultList = this.$route.query.resultList as OrderResultListDto[]
  }

  /* 跳转到订单详情页 */
  toOrderDetail (id: string, routeId: number) {
    this.$router.replace({
      path: '/purchaseOrderDetail',
      query: {
        orderId: id,
        currRouteId: String(routeId)
      }
    })
  }

  /* 跳转到订货单页面 */
  toShopOrderList () {
    this.$router.replace('/customerManage')
    toOrderReturn()
    // this.$router.replace('/orderManage/purchaseOrderList')
  }

  /**
   * @description: 监听复制
   * @param {*} e 复制内容
   * @return {*}
   */
  onCopy (key) {
    let clipboard = new Clipboard('.copy', {
      text: trigger => key
    })
    clipboard.on('success', e => {
      this.$toast('复制成功')
    })
    clipboard.on('error', e => {
      this.$toast('该浏览器不支持复制')
      e.clearSelection()
    })
  }
}
